import { useState, useEffect, useCallback } from "react";
import NoRecordFound from "../../../components/ui/noRecordFound/NoRecordFound";
import ToastService from "../../../services/toastService/ToastService";

const ModalGroupingTable = ({ data = [], onChange, onApplicationNumberBlur,isDisabled }) => {
    // local controlled copies so we can revert on invalid blur
    const [appNumberValues, setAppNumberValues] = useState({});
    const [ratingValues, setRatingValues] = useState({});
    const [ratingErrors, setRatingErrors] = useState({});
    const [certPrefixValues, setCertPrefixValues] = useState({});
    const [certPrefixErrors, setCertPrefixErrors] = useState({});

    // useEffect(() => {
    //     const initialApp = {};
    //     const initialRating = {};
    //     data?.forEach((item) => {
    //         initialApp[item.sgbpProductId] = item.applicationNumber ?? "";
    //         initialRating[item.sgbpProductId] = item.rating ?? "";
    //     });
    //     setAppNumberValues(initialApp);
    //     setRatingValues(initialRating);
    //     setRatingErrors({});
    // }, [data]);

    useEffect(() => {
        const initialApp = {};
        const initialRating = {};
        const initialCertPrefix = {};
        data?.forEach((item) => {
            initialApp[item.sgbpProductId] = item.applicationNumber ?? "";
            initialRating[item.sgbpProductId] = item.rating ?? "";
            initialCertPrefix[item.sgbpProductId] = item.certPrefix ?? null;
        });
        setAppNumberValues(initialApp);
        setRatingValues(initialRating);
        setCertPrefixValues(initialCertPrefix);
        setRatingErrors({});
        setCertPrefixErrors({});
    }, [data]);

    const handleAppNumberChange = useCallback((id, value) => {
        setAppNumberValues((prev) => ({ ...prev, [id]: value }));
    }, []);

    // const handleAppNumberBlur = useCallback((id, originalValue) => {
    //     // kept as-is for now, per requirement (future change)

    //     debugger
    //     setAppNumberValues((prev) => {
    //         const typedValue = prev[id];
    //         if (typedValue === originalValue) return prev; // nothing changed, skip

    //         const isValid = onApplicationNumberBlur(id, typedValue);
    //         if (!isValid) {
    //             return { ...prev, [id]: originalValue };
    //         }
    //         return prev;
    //     });
    // }, [onApplicationNumberBlur]);

   const handleAppNumberBlur = useCallback(async (id, originalValue) => {
    const typedValue = appNumberValues[id];
    if (typedValue === originalValue) return; // nothing changed, skip

    const isValid = await onApplicationNumberBlur(id, typedValue);
    if (!isValid) {
        setAppNumberValues((prev) => ({ ...prev, [id]: originalValue }));
    }
}, [appNumberValues, onApplicationNumberBlur]);
   
    const handleRatingChange = useCallback((id, value) => {
        setRatingValues((prev) => ({ ...prev, [id]: value }));
        // clear stale error the moment user starts typing again
        setRatingErrors((prev) => {
            if (!prev[id]) return prev;
            const next = { ...prev };
            delete next[id];
            return next;
        });
    }, []);

    const handleRatingBlur = useCallback((id, originalValue) => {
        setRatingValues((prev) => {
            const typedValue = prev[id];
            const trimmed = String(typedValue ?? "").trim();

            // empty -> default to 0
            if (trimmed === "") {
                onChange(id, "rating", 0);
                setRatingErrors((prevErr) => {
                    if (!prevErr[id]) return prevErr;
                    const next = { ...prevErr };
                    delete next[id];
                    return next;
                });
                return { ...prev, [id]: 0 };
            }

            // only digits allowed
            const isValid = /^\d+$/.test(trimmed);

            if (!isValid) {
                ToastService.error("Rating must contain digits only.");
                setRatingErrors((prevErr) => ({ ...prevErr, [id]: "Rating must contain digits only." }));
                return { ...prev, [id]: originalValue };
            }

            setRatingErrors((prevErr) => {
                if (!prevErr[id]) return prevErr;
                const next = { ...prevErr };
                delete next[id];
                return next;
            });
            onChange(id, "rating", trimmed);
            return { ...prev, [id]: trimmed };
        });
    }, [onChange]);

    const handleCertPrefixChange = useCallback((id, value) => {
        setCertPrefixValues((prev) => ({ ...prev, [id]: value }));
        // clear stale error the moment user starts typing again
        setCertPrefixErrors((prev) => {
            if (!prev[id]) return prev;
            const next = { ...prev };
            delete next[id];
            return next;
        });
    }, []);

  const handleCertPrefixBlur = useCallback((id, originalValue) => {
    setCertPrefixValues((prev) => {
        const typedValue = prev[id];
        const trimmed = String(typedValue ?? "").trim();

        // empty -> null
        if (trimmed === "") {
            onChange(id, "certPrefix", null);
            setCertPrefixErrors((prevErr) => {
                if (!prevErr[id]) return prevErr;
                const next = { ...prevErr };
                delete next[id];
                return next;
            });
            return { ...prev, [id]: null };
        }

        // only digits allowed
        const isValid = /^\d+$/.test(trimmed);

        if (!isValid) {
            ToastService.error("Cert Suffix must contain digits only.");
            setCertPrefixErrors((prevErr) => ({ ...prevErr, [id]: "Cert Suffix must contain digits only." }));
            return { ...prev, [id]: originalValue };
        }

        setCertPrefixErrors((prevErr) => {
            if (!prevErr[id]) return prevErr;
            const next = { ...prevErr };
            delete next[id];
            return next;
        });
        onChange(id, "certPrefix", trimmed);
        return { ...prev, [id]: trimmed };
    });
}, [onChange]);

    return (
        <>
            <div className="table-title mt-2">
                <h3>Model Grouping</h3>
            </div>

            {data?.length > 0 ? <div className="member-list">
                <div className="content-section">
                    <div className="table-section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Brand Name</th>
                                    <th>Model Name</th>
                                    <th>Rating</th>
                                    <th>Text Value</th>
                                    <th>Cert Number</th>
                                    <th>Cert Suffix</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.map((item) => (
                                    <tr key={item.sgbpProductId}>
                                        <td>{item.brandName || "N/A"}</td>
                                        <td>{item.modelName || "N/A"}</td>

                                        <td>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className={`form-control${ratingErrors[item.sgbpProductId] ? " is-invalid" : ""}`}
                                                    value={ratingValues[item.sgbpProductId] ?? ""}
                                                    onChange={(e) => handleRatingChange(item.sgbpProductId, e.target.value)}
                                                    onBlur={() => handleRatingBlur(item.sgbpProductId, item.rating)}
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                            {ratingErrors[item.sgbpProductId] && (
                                                <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                    {ratingErrors[item.sgbpProductId]}
                                                </div>
                                            )}
                                        </td>

                                        <td>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    defaultValue={item.textValue}
                                                    onChange={(e) => onChange(item.sgbpProductId, "textValue", e.target.value)}
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={appNumberValues[item.sgbpProductId] ?? ""}
                                                    onChange={(e) => handleAppNumberChange(item.sgbpProductId, e.target.value)}
                                                    onBlur={() => handleAppNumberBlur(item.sgbpProductId, item.applicationNumber)}
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            {/* <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    defaultValue={item?.certPrefix ?? ""}
                                                    onChange={(e) => onChange(item?.sgbpProductId, "certPrefix", e.target.value)}
                                                />
                                            </div> */}
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className={`form-control${certPrefixErrors[item.sgbpProductId] ? " is-invalid" : ""}`}
                                                    value={certPrefixValues[item.sgbpProductId] ?? ""}
                                                    onChange={(e) => handleCertPrefixChange(item.sgbpProductId, e.target.value)}
                                                    onBlur={() => handleCertPrefixBlur(item.sgbpProductId, item.certPrefix)}
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                            {certPrefixErrors[item.sgbpProductId] && (
                                                <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                    {certPrefixErrors[item.sgbpProductId]}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> : <NoRecordFound />}
        </>
    );
};

export default ModalGroupingTable;
